const STORAGE_KEY = "social-auth-state";

/** A random value tying a provider callback to the browser that started the sign-in. */
export const createSocialAuthState = (): string => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join(
    "",
  );
};

export const rememberSocialAuthState = (state: string) =>
  sessionStorage.setItem(STORAGE_KEY, state);

/** The state this browser kept, removed so it can only be used once. */
export const takeSocialAuthState = (): string | null => {
  const state = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  return state;
};

/**
 * Whether a provider callback belongs to this browser's sign-in.
 *
 * A callback that carries a state must match the one kept here (a link made from someone else's
 * sign-in never does), and a kept state means the callback must carry it. With neither there is
 * nothing to compare: the backend did not ask for one, which the server enforces where it does.
 */
export const isSocialAuthStateValid = (
  returned: string | undefined,
  kept: string | null,
): boolean => (returned || kept ? returned === kept : true);
